import { useEffect } from 'react';

import LabelManagement from '~components/Labeling/LabelManagement';
import { MIXPANEL_EVENT } from '~libs/mixpanel/event';
import { mixpanel } from '~pages/_app';

export const PAGE_NAME = 'LabelManagement' as const;

const LabelManagementPage = () => {
  useEffect(() => {
    mixpanel.track(MIXPANEL_EVENT.VIEW.CLOBE_PAGE, {
      page: PAGE_NAME,
    });
  }, []);
  return <LabelManagement />;
};

export default LabelManagementPage;
